import { checkRequiredFields } from "./register-validation/common";
import {
  getPasswordErrorMessage,
  getConfirmedPasswordErrorMessage,
} from "./register-validation/passwordValidation";

/**
 * Обязательные поля для формы сброса пароля
 */
export const PASSWORD_RESET_REQUIRED_FIELDS = {
  password: "Пароль",
  confirmedPassword: "Подтверждение пароля",
};

/**
 * Полная валидация формы сброса пароля
 */
export const validatePasswordResetForm = (formData) => {
  const requiredCheck = checkRequiredFields(
    formData,
    PASSWORD_RESET_REQUIRED_FIELDS,
  );

  if (requiredCheck.isEmpty) {
    return {
      fieldErrors: requiredCheck.fieldErrors,
      messages: {
        password: "",
        confirmedPassword: "",
      },
      isValid: false,
      requiredFieldsError: requiredCheck.message,
    };
  }

  const passwordError = getPasswordErrorMessage(formData.password);
  const confirmedPasswordError = getConfirmedPasswordErrorMessage(
    formData.password,
    formData.confirmedPassword,
  );

  const messages = {
    password: passwordError || "",
    confirmedPassword: confirmedPasswordError || "",
  };

  const hasErrors = passwordError || confirmedPasswordError;

  return {
    fieldErrors: {
      password: !!passwordError,
      confirmedPassword: !!confirmedPasswordError,
    },
    messages,
    isValid: !hasErrors,
    requiredFieldsError: null,
  };
};

/**
 * Валидация полей при потере фокуса
 */
export const passwordResetValidateOnBlur = {
  password: (value) => getPasswordErrorMessage(value),
  confirmedPassword: (value, formData) =>
    getConfirmedPasswordErrorMessage(formData?.password, value),
};

/**
 * Поля, которые нужно очищать при изменении
 */
export const passwordResetClearOnChange = ["password", "confirmedPassword"];
